/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcFundingV1BatchTransferEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_FUNDING_V1_BATCH_TRANSFER_EVENT_ENTITY_NAME = 'ixc.funding.v1.BatchTransferEvent';
export const ixcFundingV1BatchTransferEventEntity = new schema.Entity<IxcFundingV1BatchTransferEvent>(IXC_FUNDING_V1_BATCH_TRANSFER_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcFundingV1BatchTransferEvent) => `${entity.metadata?.eventId}` });

